import { useRef, useState, useCallback } from "react";
import { MoveHorizontal } from "lucide-react";
import { resolveSrc } from "@/api";

// image = photo "après" (obligatoire). before = vraie photo "avant"
// (optionnelle) : si absente, un traitement visuel simule le "avant".
const BeforeAfter = ({ image, before, alt, testid }) => {
  const ref = useRef(null);
  const [pos, setPos] = useState(50);
  const hasRealBefore = Boolean(before);

  const update = useCallback((clientX) => {
    if (!ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    setPos(Math.min(96, Math.max(4, ((clientX - rect.left) / rect.width) * 100)));
  }, []);

  return (
    <div
      ref={ref}
      data-testid={testid}
      onPointerDown={(e) => {
        e.currentTarget.setPointerCapture(e.pointerId);
        update(e.clientX);
      }}
      onPointerMove={(e) => {
        if (e.buttons === 1) update(e.clientX);
      }}
      className="relative aspect-[4/3] w-full cursor-ew-resize select-none overflow-hidden bg-plaster"
      style={{ touchAction: "pan-y" }}
    >
      <img
        src={resolveSrc(image)}
        alt={`${alt} — après travaux`}
        draggable={false}
        loading="lazy"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}>
        <img
          src={resolveSrc(before || image)}
          alt={`${alt} — avant travaux`}
          draggable={false}
          loading="lazy"
          className="absolute inset-0 h-full w-full object-cover"
          style={hasRealBefore ? undefined : { filter: "grayscale(0.65) sepia(0.4) brightness(0.72) contrast(0.92)" }}
        />
      </div>
      <div
        className="absolute inset-y-0 w-px bg-cream/90"
        style={{ left: `${pos}%` }}
        aria-hidden="true"
      >
        <span className="absolute left-1/2 top-1/2 flex h-11 w-11 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-clay text-cream shadow-lg">
          <MoveHorizontal size={18} />
        </span>
      </div>
      {!hasRealBefore && (
        <>
          <span className="absolute left-3 top-3 bg-ink/70 px-3 py-1 text-[10px] uppercase tracking-[0.25em] text-cream">
            Avant
          </span>
          <span className="absolute right-3 top-3 bg-clay px-3 py-1 text-[10px] uppercase tracking-[0.25em] text-cream">
            Après
          </span>
        </>
      )}
    </div>
  );
};

export default BeforeAfter;
